import { render, staticRenderFns } from "./UserDrawerFooter.vue?vue&type=template&id=7e0b9c94&scoped=true&"
import script from "./UserDrawerFooter.vue?vue&type=script&lang=js&"
export * from "./UserDrawerFooter.vue?vue&type=script&lang=js&"
import style0 from "./UserDrawerFooter.vue?vue&type=style&index=0&id=7e0b9c94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0b9c94",
  null
  
)

export default component.exports